import type { Corpus } from '../models/Corpus';
import { LocalCorpus } from './LocalCorpus';
import { PublicDomainCorpus } from './PublicDomainCorpus';

class CorpusRegistryService {
    private corpora: Map<string, Corpus> = new Map();
    private activeId: string = 'public_domain_gutendex';

    constructor() {
        this.register(new PublicDomainCorpus());

        const saved = localStorage.getItem('active_corpus_id');
        if (saved && this.corpora.has(saved)) {
            this.activeId = saved;
        }
    }

    register(c: Corpus) {
        this.corpora.set(c.id, c);
    }

    async init() {
        // Load Siddhartha Manifest if present
        try {
            const res = await fetch('/corpora/siddhartha/manifest.json');
            if (res.ok) {
                const manifest = await res.json();
                const c = new LocalCorpus({
                    id: manifest.id,
                    title: manifest.title,
                    author: manifest.author,
                    language: manifest.language,
                    source: {
                        type: 'html',
                        path: '/corpora/siddhartha/siddhartha.html'
                    }
                });
                this.register(c);
            }
        } catch (e) {
            console.warn("Failed to load Siddhartha manifest", e);
        }

        const saved = localStorage.getItem('active_corpus_id');
        if (saved && this.corpora.has(saved)) {
            this.activeId = saved;
        }
    }

    getAll(): Corpus[] {
        return Array.from(this.corpora.values());
    }

    get(id: string): Corpus | undefined {
        return this.corpora.get(id);
    }

    getActive(): Corpus {
        return this.corpora.get(this.activeId) || this.corpora.get('public_domain_gutendex')!;
    }

    setActive(id: string) {
        if (this.corpora.has(id)) {
            this.activeId = id;
            localStorage.setItem('active_corpus_id', id);
            return true;
        }
        return false;
    }
}

export const CorpusService = new CorpusRegistryService();
export default CorpusService;
